import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Repeat } from 'lucide-react';

// Homepage nudge for workshops already on other software.
export const SwitchStrip = () => (
  <section className="mx-auto max-w-7xl px-5 sm:px-8" data-testid="home-switch-strip">
    <Link to="/driveline/switch" className="group flex flex-wrap items-center gap-4 rounded-3xl border border-[#cbd5e1] bg-[#ffffff] px-6 py-5 transition-colors hover:border-[#0f766e]" data-testid="home-switch-link">
      <span className="flex h-10 w-10 items-center justify-center rounded-full bg-[#ccfbf1] text-[#0f766e]"><Repeat size={18} /></span>
      <span className="min-w-0 flex-1"><b className="text-[#0f172a]">Switching from another software?</b> <span className="text-[#475569]">We move your customers, dues and stock for you, free. Live in 7 days.</span></span>
      <span className="inline-flex items-center gap-1.5 text-sm font-semibold text-[#0f766e]">See how <ArrowRight size={15} className="transition-transform group-hover:translate-x-1" /></span>
    </Link>
  </section>
);
